import React, {FunctionComponent, FormEvent, ChangeEvent, useState, createRef,} from 'react';

import {
  Button,
  Grid,
  Card,
  CardContent,
  TextField,
  Alert
} from '@mui/material';
import {
  LoadingButton,
} from '@mui/lab'
import {useDispatch, useSelector} from 'react-redux';
import {AppDispatch, RootState} from '../../../store/store';
import {updateEmailAttribute,} from './update-your-email';
import {useTranslation} from 'react-i18next';
import {push} from '@lagunovsky/redux-react-router';
import useValidator from '../../../helpers/hooks/use-validator';

interface Props {
}

const UpdateYourEmail: FunctionComponent<Props> = (props) => {

  const {t} = useTranslation(['settings']);

  const dispatch = useDispatch<AppDispatch>();

  const [email, setEmail] = useState(useSelector((state: RootState) => state.app.attributes.email));
  const [modified, setModified] = useState(false);
  const [verificationEmailSent, setVerificationEmailSent] = useState(false);

  const emailVerified = useSelector((state: RootState) => state.app.attributes.email_verified);
  const [ initialEmail ] = useState(email);
  //const [ initialEmail ] = useState(email);
  const onEmailChange = (event: ChangeEvent) => {
    const target = event.target as HTMLInputElement;
    setEmail(target.value);
    setModified(initialEmail != target.value);
  }

  const emailInputRef = createRef<HTMLInputElement>();

  useValidator( [ emailInputRef ] )
    .required()
    .noSpecialCharacters()
    .noEmpty();

  const loading = useSelector((state: RootState) => state.pages.settings.updateYourEmail.loading);

  const onUpdateYourEmail = (event: FormEvent) => {

    event.preventDefault();

    const target = event.target as HTMLFormElement;
    const data = Object.fromEntries(new FormData(target));

    setVerificationEmailSent(true);

    dispatch( updateEmailAttribute(
      ( data.email as string ).trim(),
    ) ).then(action => {
      // history.push( '/verify-email' );
    });
  }

  const onVerify = () => {
    dispatch(push('/verify-email'));
  }

  return (
    <Card sx={{mt: 4}}>
      <CardContent>
        <h2>{ t( 'update-your-email' ) }</h2>
        <form onSubmit={ onUpdateYourEmail }>
          <Grid container spacing={4}>
            <Grid item xs={12} sm={6}>
              <TextField
                required
                spellCheck="false"
                autoCapitalize="off"
                value={ email }
                onChange={ onEmailChange }
                inputRef={ emailInputRef }
                type='email'
                label={ t( 'email' ) }
                name="email"
                variant='standard'
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              {!emailVerified &&
                <Alert
                  severity='warning'
                  action={<Button
                    color="inherit"
                    size="small"
                    onClick={onVerify}
                  >{t('resend')}</Button>}
                >{t('email-is-not-verified-yet')}</Alert>
              }
            </Grid>
          </Grid>
          <Grid container>
            <Grid item xs={12} sm={6}>
              <p>{t('submit-new-email-info')}</p>
              {t('new-login-info')}
            </Grid>
            <Grid item xs={12} sm={6} style={{display: 'flex'}}>
              <Grid container justifyContent='flex-end' alignContent={'end'}>
                <LoadingButton
                  disabled={!modified}
                  loading={loading === 'pending'}
                  variant='contained'
                  type="submit"
                >
                  {verificationEmailSent ? t('resend-verification') : t( 'save' )}
                </LoadingButton>
              </Grid>
            </Grid>
          </Grid>
        </form>
      </CardContent>
    </Card>
  );
}

export default UpdateYourEmail;
